import { WifiOff } from 'lucide-react';
import { useSyncExternalStore } from 'react';

function subscribe(callback: () => void) {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

/** Visible while the device has no connection; pending actions retry when it returns. */
export function OfflineBanner() {
  const online = useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
  if (online) return null;
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-warning px-4 py-2 text-sm text-warning-foreground"
    >
      <WifiOff className="size-4" aria-hidden="true" />
      Sin conexión. Revisa tu internet; reintentaremos automáticamente cuando vuelva.
    </div>
  );
}
